import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import type { AppState } from 'store/store';
import { useNavigateReplace, useSafeParams } from 'hooks';
import { useGetBlankQuery, useInfoUserQuery } from 'store/api';

import { ClientBlankEstimate } from './client-blank-estimate';
import { ClientGoal, ClientGoalSheet } from './client-blank-goal';
import { ClientInfo, ClientInfoSheet } from './client-blank-info';
import { Loader, LoaderAdaptive } from './utils';
import { useMediaQuery } from '@mui/material';
import { divide } from 'lodash';
import { Button, Icon } from '@gravity-ui/uikit';
import { ArrowLeft } from '@gravity-ui/icons';
import { useCallback } from 'react';
import { routes } from 'routes';
import styles from './styles.module.scss';

export const ClientBlank = () => {
	const { clientId } = useSafeParams();

	const { data, isLoading, refetch } = useGetBlankQuery(clientId ?? skipToken, {
		refetchOnMountOrArgChange: true,
	});

	const navigate = useNavigateReplace();

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => {
			e.preventDefault();
			navigate(routes.blank.path);
		},
		[navigate],
	);

	const isAdaptive = useMediaQuery('(max-width: 768px)');

	const isMobile = useMediaQuery('(max-width: 520px)');

	const token = useSelector((state: AppState) => state.userState.token);

	const { data: response } = useInfoUserQuery(token ? null : skipToken);

	const role = response?.role;

	if (!data || isLoading) {
		return <>{isAdaptive ? <LoaderAdaptive /> : <Loader />}</>;
	}

	const handleAddEstimate = () => {
		refetch();
	};

	//TODO если вдруг ошибка по данным, нужно добавить попап
	//TODO поправить skeleton

	return (
		<>
			{isMobile ? (
				<div className={styles.header_mobile_block}>
					<Button size="l" view="outlined" onClick={handleClick}>
						<Icon data={ArrowLeft} size={20} />
					</Button>
					<h2>{role === 'ADMIN' ? data.id : `${data.lastName} ${data.firstName} ${data.middleName}`}</h2>
				</div>
			) : (
				<h2>{role === 'ADMIN' ? data.id : `${data.lastName} ${data.firstName} ${data.middleName}`}</h2>
			)}

			<div className={styles.blank_info}>
				{isMobile ? <ClientInfoSheet data={data} /> : <ClientInfo data={data} />}
				{isMobile ? <ClientGoalSheet data={data} /> : <ClientGoal data={data} />}
			</div>

			<ClientBlankEstimate data={data} onAdd={handleAddEstimate} isMobile={isMobile} />
		</>
	);
};
